import StepWizard from '../../../commons/StepWizard/StepWizard';
import { StepWizardStep } from '../../../commons/StepWizard/StepWizard.types';
import InitPasswordForm from './InitPasswordForm/InitPasswordForm';

export default () => {
  const steps: StepWizardStep[] = [
    {
      step: 1,
      component: InitPasswordForm,
      title: 'Mot de passe',
      subtitle: 'Renseignez un mot de passe',
    },
  ];

  return <StepWizard {...{ steps }} />;
};
